import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const LegacyDetailPage = lazy(() => import('./Invoice.page'));

export const LegacyDetail = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <LegacyDetailPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
